import { render, staticRenderFns } from "./VenL.vue?vue&type=template&id=56a73cba"
import script from "./VenL.vue?vue&type=script&lang=js"
export * from "./VenL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports